import "./asnGRNViewDetails.css";
import React, { useState, useEffect } from "react";
import { authKey, GET_STAKEHOLDER_CATEGORY, GET_CONSIGNMENT_DETAILS_BY_NUMBER, TRIP_END_READING, UPDATE_UNLOADING_aLLOWED_FLAG, PRINT_DOWNLOAD_DATA, GET_DELIVERY_CHALLAN_DETAILS } from '../../../common/URLs';

import jwt from "jwt-decode";
import { confirmAlert } from 'react-confirm-alert';
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { UnloadingDetailsPopover } from "./unloadingDetailsPopover";
import { OdoMeterPopover } from './odoMeterPopover';
import { useLocation } from 'react-router-dom';
import Moment from 'moment';
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD, PIT_ROLES, NO_DATA_AVAILABLE } from "../../../common/constants";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { userData } from '../../../common/spinLoader';
import { toast } from 'react-toastify';
import { Card, CardContent, Box, Fab, TextField, Typography, Container, Stack, Grid, Divider } from '@mui/material';
import BackButton from "../../../common/backButton";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { ApproveIcon, ProceedIcon, TransportIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { useTranslation } from 'react-i18next';

function AsnGrnViewDetails() {
    const { t } = useTranslation();
    const userLoggedInRole = userData?.user?.userRoles?.[0]?.roleName;
    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const consignmentData = useLocation().state?.selectedRow;
    const [tripEndedData, setTripEndedData] = useState();
    const [consignmentDetails, setConsignmentDetails] = useState([]);
    const [showTripEnd, setShowTripEnd] = useState(true);
    const { state } = useLocation();
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const role = localStorage.getItem("role");
    const hasCategory = !!stakeholderDetails?.category;
    const isRaw = state?.selectedRow?.asnType === "RawBamboo";
    const isChip = state?.selectedRow?.asnType === "ChipBamboo";
    const [role1, setRole1] = useState(false);
    const [role2, setRole2] = useState(false);
    const [deliveryChallanDetails, setDeliveryChallanDetails] = useState();

    const isWeighbridgeOperatorRole = [PIT_ROLES?.PitWeighbridgeOperator, PIT_ROLES?.PitManualWeighbridgeOperator, PIT_ROLES?.PitUnloader].includes(role);


    const [confirmOpen3, setConfirmOpen3] = useState(false);
    const handleConfirmOpen3 = () => setConfirmOpen3(true);
    const handleConfirmClose3 = () => setConfirmOpen3(false);

    const [allowUnloading, setAllowUnloading] = useState(false);
    const handleAllowUnloading = () => setAllowUnloading(true);
    const handleCloseAllowUnloading = () => setAllowUnloading(false);

    const [logModalOpen4, setLogModalOpen4] = useState(false);
    const handleLogModalOpen4 = () => setLogModalOpen4(true);
    const handleLogModalClose4 = () => setLogModalOpen4(false);


    useEffect(() => {
        if (userLoggedInRole) {
            if (userLoggedInRole === PIT_ROLES.PitScmUser) {
                setRole1(true);
            }
            if (userLoggedInRole === PIT_ROLES.ProcessingIncharge) {
                setRole2(true);
            }
        }
        getViewDetails();
    }, [tripEndedData]);

    const getStakeDetails = (conDetails) => {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                if (response?.data?.category === conDetails?.consignmentDestinationType) {
                    setRole1(true)
                }
                setStakeholderDetails(response.data)

                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });
    }
    //console.log("stakeholderDetails", stakeholderDetails)
    // const [showGrid, setShowGrid] = useState(false);
    // const [hideClickHere, setHideClickHere] = useState(true);
    // const [yesVisible, setYesVisible] = useState("");
    // const [noVisible, setNoVisible] = useState("");

    // const handleShowGrid = (e) => {
    //   e.preventDefault();
    //   if (e.target.value === "yes") {
    //     setYesVisible(true);
    //     setNoVisible(false);
    //   } else {
    //     setYesVisible(false);
    //     setNoVisible(true);
    //   }
    // };
    const getViewDetails = () => {
        let data = {
            consignmentNumber: consignmentData?.consignmentNo,
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader()
        apiClient
            .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER, data, { headers })
            .then(res => {
                setConsignmentDetails(res.data);
                res.data?.isDbsAsn && getChallanDetails(res.data?.delieryChallanNumber)
                decoded.extension_URN && getStakeDetails(res.data)
                if (res?.data?.consignmentMilestones?.length > 0) {
                    if (res?.data?.consignmentMilestones[0]?.eventType == "TripEnded") {
                        setShowTripEnd(false)
                    }
                }
            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);
            });
        loaderService.hideLoader();
    };


    const onClickEdit = (e) => {
        e.preventDefault();

        confirmAlert({

            customUI: ({ onClose }) => {

                return (

                    <UnloadingDetailsPopover onClose={onClose} />

                );

            }

        });
    }

    const onProceed = (e) => {
        navigate('./asnProceed', {
            state: {
                consignmentDetails,
                tabValue: state?.tabValue,
            },
        });
    };

    const onAllowUnloading = () => {
        handleAllowUnloading();
    }

    const onConfirmAllowUnloading = () => {
        handleCloseAllowUnloading();
        apiClient
            .post(UPDATE_UNLOADING_aLLOWED_FLAG,
                {
                    "consignmentId": consignmentDetails?.id,
                    "isUnloadingAllowed": true
                }, {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            })
            .then(res => {
                getViewDetails();
            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);
            });

    }

    const onConfirmEndTrip = (e) => {
        handleConfirmClose3();
        tripEnded();
    }

    const onEndTrip = (e) => {
        handleConfirmOpen3();
    }

    const tripEnded = (data) => {
        let req = {
            consignmentNo: consignmentDetails.consignmentNo,
            // odometerReading: odoMeterReading ? odoMeterReading : ""
        };
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        apiClient
            .post(TRIP_END_READING, data ? data : req, { headers })
            .then(res => {
                if (res.data.isSuccess === true) {
                    setTripEndedData(res.data)
                    toast.success("Trip Ended Successfully")
                    getViewDetails();
                }
                else toast.error(res.data.message)

            })
            .catch(function (err) {
                console.log(err);
                toast.error(err.message);
            });
    }

    const onClickEndTrip = (onClose) => {
        // e.preventDefault();
        handleLogModalOpen4(onClose);
    }

    const columns = [
        { field: 'sourceStakeholderUrn', headerName: 'Pick-up Location URN', width: 200 },
        {
            field: 'sourceLocationName', headerName: 'Pick-up Location Name', width: 200
        },
        {
            field: 'sourceLocationAddress', headerName: 'Pick-Up Location Address', width: 200
        },

    ];

    const getChallanDetails = (chalaanNo) => {
        loaderService.showLoader()
        apiClient
            .post(
                GET_DELIVERY_CHALLAN_DETAILS,
                {
                    "challanNo": chalaanNo,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setDeliveryChallanDetails(response.data.challanDetails);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                toast.error(error.message);
            });
    };

    const getDownloadChallan = (action) => {
        // console.log("Print");
        loaderService.showLoader();
        apiClient
            .post(PRINT_DOWNLOAD_DATA,
                {
                    "printDataByNumber": consignmentDetails?.delieryChallanNumber,
                    "printDetailsType": "delivery_challan",
                },
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

                        Accept: 'application/pdf'
                    }
                }, null
            )
            .then((response) => {
                const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

                if (action === "download") {
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `Output.pdf`
                    );
                    document.body.appendChild(link);

                    link.click();
                    link.parentNode.removeChild(link);
                }
                if (action === "print") {
                    let iframe = document.createElement('iframe');
                    document.body.appendChild(iframe);
                    iframe.style.display = 'none';
                    iframe.src = url;
                    iframe.onload = function () {
                        setTimeout(function () {
                            iframe.focus();
                            iframe.contentWindow.print();
                        }, 1);
                    };
                }
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const canShowButton = stakeholderDetails
        ? (stakeholderDetails?.category === 'LLE' && isRaw)
        : (role === PIT_ROLES?.PitScmUser && (isRaw || isChip));

    return (

        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT07</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        <Fab onClick={() => { navigate('../asnGRN', { state: { tabValue: state?.tabValue } }) }} size="small" aria-label="back" title='Back'>
                            <KeyboardArrowLeftRounded />
                        </Fab>  {consignmentDetails.isDbsAsn ? "ASN DBS Details" : "Consignment Details"}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12} >
                                <Grid container spacing={3}>
                                    {consignmentDetails.isDbsAsn && <>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth size="small" label="PO Number" value={deliveryChallanDetails?.poNumber || ''} disabled={true} />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth size="small" label="Delivery ChallanDate" value={moment(deliveryChallanDetails?.challanDate).format("DD/MM/YYYY") || ''} disabled={true} />
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth size="small" label="Quantity(in MT)" value={consignmentDetails?.destinationNetWeight ? consignmentDetails?.destinationNetWeight : consignmentDetails?.Pickupnetweight ? consignmentDetails?.Pickupnetweight : consignmentDetails?.consignmentWeight} disabled={true} />
                                        </Grid></>}
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label={consignmentDetails.isDbsAsn ? "Asn Number" : "Consignment"} value={consignmentDetails.consignmentNo || ''} disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label={(!consignmentDetails.isDbsAsn ? "Consignment " : "") + "Owner URN"} value={consignmentDetails.consignmentSourceUrn || ''} disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label={(!consignmentDetails.isDbsAsn ? "Consignment " : "") + "Owner Name"} value={consignmentDetails.consignmentOwnerName || ''} disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label={(!consignmentDetails.isDbsAsn ? "Consignment " : "") + "Owner Contact"} value={consignmentDetails.consignmentOwnerContactNo || ''} disabled={true} />
                                    </Grid>
                                    {!consignmentDetails.isDbsAsn && <><Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Date of loading completion" value={consignmentDetails.loadingCompleteDate && Moment(consignmentDetails.loadingCompleteDate).format('DD/MM/YYYY') || ''} name="" disabled={true} />
                                    </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth size="small" label="Average Moisture during the pickup" value={consignmentDetails.totalMoisture || ''} disabled={true} />
                                        </Grid></>}
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Schedule date" value={consignmentDetails.consignmentScheduleDate && Moment(consignmentDetails.consignmentScheduleDate).format('DD/MM/YYYY') || ''} name="" disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Driver License number" value={consignmentDetails.driverLicenseNo || ''} disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Driver Contact" value={consignmentDetails.driverContact || ''} disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Delivery Location URN" value={consignmentDetails.consignmentDestinationStakeholderUrn || ''} disabled={true} />
                                    </Grid>
                                    {consignmentDetails.isDbsAsn && <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Delivery Location GST" value={deliveryChallanDetails?.challanSourceDestinationDetails?.[0]?.destinationGSTIN || ''} disabled={true} />
                                    </Grid>}
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Delivery Location Name" value={consignmentDetails.consignmentDestinationLocationName || ''} disabled={true} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Delivery Location Address" value={consignmentDetails.consignmentDestinationLocationAddress || ''} disabled={true} />

                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Vehicle Registration" value={consignmentDetails.vehicleRegNo || ''} disabled={true} />

                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Driver Name" value={consignmentDetails.driverName || ''} disabled={true} />
                                    </Grid>
                                    {!consignmentDetails.isDbsAsn && <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Total weight (in MT)picked up" value={consignmentDetails.totalWeight || ''} disabled={true} />
                                    </Grid>}
                                    {consignmentDetails?.consignmentMilestones?.find(item => item?.eventType === "TripStarted") && <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="Start Trip Odometer Reading" value={consignmentDetails.consignmentMilestones?.find(item => item?.eventType === "TripStarted")?.odometerReading || ''} disabled={true} />
                                    </Grid>}
                                    {!consignmentDetails.isDbsAsn && consignmentDetails?.consignmentMilestones?.find(item => item?.eventType === "TripEnded") && <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small" label="End Trip Odometer Reading" value={consignmentDetails.consignmentMilestones?.find(item => item?.eventType === "TripEnded")?.odometerReading || ''} disabled={true} />
                                    </Grid>}
                                    <Divider sx={{
                                        width: '105%',
                                        bgcolor: 'black',
                                        marginTop: '3vh'
                                    }} mt={2} />
                                    <Grid item xs={12} lg={12}>
                                        <Typography variant="h5" gutterBottom>Pick-up Details</Typography>
                                        {consignmentDetails?.consignmentSourceDetails?.length !== 0 ?
                                            <Box style={{ height: 300, width: '100%' }}>
                                                {
                                                    consignmentDetails?.consignmentSourceDetails &&
                                                    <DataGrid rows={consignmentDetails?.consignmentSourceDetails}
                                                        columns={columns}
                                                        pageSize={5}
                                                    // getRowId={(row) => row.bundleId}

                                                    />
                                                }
                                            </Box>
                                            : <Typography display="flex" justifyContent='center'>{NO_DATA_AVAILABLE}</Typography>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    {consignmentDetails.isDbsAsn && <Button hidden={isWeighbridgeOperatorRole} variant="contained" sx={{ ml: 2 }} onClick={() => getDownloadChallan("print")}>Print Delivery Challan</Button>}
                    {(localStorage?.getItem('role') === PIT_ROLES.PlantSCMOperator || localStorage?.getItem('role') === PIT_ROLES.PitScmUser || stakeholderDetails) && consignmentDetails?.isMeasurementDone === true ?
                        <>
                            <Button startIcon={<TransportIcon />} sx={{ minWidth: 100 }} hidden={consignmentDetails?.isTripEnded} variant="contained" onClick={(e) => { !consignmentDetails.isDbsAsn ? onClickEndTrip() : onEndTrip(e) }}>End Trip</Button>

                            {/* <Button sx={{ minWidth: 100 }} hidden={!consignmentDetails.isDbsAsn && consignmentDetails?.isTripEnded} variant="contained" onClick={(e) => onEndTrip(e)}>End Trip</Button> */}
                        </>
                        : null
                    }

                    <Button startIcon={<ApproveIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" hidden={!canShowButton} disabled={consignmentDetails?.isUnloadingAllowed} onClick={onAllowUnloading} type='submit'>Allow Unloading</Button>
                    <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={onProceed} type='submit'>Proceed</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmEndTrip} onClose={handleConfirmClose3} action="End Trip" />
            <ConfirmationPopover onOpen={allowUnloading} onConfirm={onConfirmAllowUnloading} onClose={handleCloseAllowUnloading} action="Allow" />
            <Dialog maxWidth='xs' fullWidth open={logModalOpen4}>
                <DialogContent>
                    <OdoMeterPopover tripEnded={tripEnded} consignmentNumber={consignmentDetails.consignmentNo} handleLogModalClose={handleLogModalClose4} />
                </DialogContent>
            </Dialog>
        </>
    );

}
export default AsnGrnViewDetails;
